import { useEffect, useRef, type ComponentProps, type FC } from 'react'

interface Props extends ComponentProps<'div'> {
  onIntersect: () => void
}

const ScrollSentinel: FC<Props> = ({
  className = '',
  onIntersect,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const classes = [
    'flex h-[40px] w-full &[>*]:min-h-[20px] &[>*]:w-full',
    className,
  ]
  useEffect(() => {
    const { current: elm } = ref
    if (!elm) return
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) {
        onIntersect()
      }
    })
    observer.observe(elm)
    return () => observer.disconnect()
  }, [onIntersect])

  return (
    <div className={classes.join(' ')} {...props}>
      <div ref={ref} />
    </div>
  )
}

export default ScrollSentinel
